module.exports = __webpack_public_path__ + "images/39c537ba01bbda629691a031abe5c2f3.svg";